import React, { useRef } from "react";

import {
  Container,
  Search,
} from "@dtpk-cc/components";

import "@dtpk-cc/components/dist/global.css";
import "@dtpk-cc/components/dist/components/Search/Search.css";
import "@dtpk-cc/components/dist/components/Icon/Icon.css";
import "@dtpk-cc/components/dist/components/TextLink/TextLink.css";
import "@dtpk-cc/components/dist/components/CopyText/CopyText.css";
import "@dtpk-cc/components/dist/components/Container/Container.css";

import styles from './App.module.css';

function App({scriptParams}) {
  const inputRef = useRef(null);

  const { searchActionUrl, searchKeywordPlaceholder, forceRedirect } = scriptParams;

  const openNexusSearch = () => {
    if(forceRedirect) {
      return;
    }

    const scripts = Array.from(document.querySelectorAll("[src*=nexus]"));
    const nexusScriptsFound = scripts.some(script => {
      const matched = script.src.match(/^https:\/\/ebs[0-9]{2}\.telekom.de\/resout\/nexus-(pk|gk|pv)-coin\/nexus-(pk|gk|pv)-coin-([^.]+)\.js$/i);
      if(matched) {
        const customerSegment = matched[1].toLowerCase();
        window.location.hash = `suche${customerSegment === 'gk' ? '-gk' : '' }?`;
        setTimeout(() => {
          document.querySelector(`.nexus-${customerSegment}-coin__search-bar input[type=text]`).focus();  
        }, 500);        
        return true;
      }
    }); 
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const keywordPlaceholder = searchKeywordPlaceholder || "{keyword}";
    const url = searchActionUrl || `https://www.telekom.de/start#suche?${keywordPlaceholder}`;

    window.location.href = url.replace(keywordPlaceholder, inputRef.current.value);
  }


  return (
    <Container
      variants={[
        Container.Variant.centered,
        Container.Variant.paddedHorizontal,
      ]}
      customClass={styles.container}
    >
      <div className={styles.search_container}>
        <Search
          items={[]}
          links={[]}
          placeholder="Suchbegriff eingeben"
          innerRef={inputRef}
          onClick={ openNexusSearch }
          onSubmit={ handleSubmit }
        />
      </div>
    </Container>
  );
}

export default App;
